import dayjs from "dayjs";

/** Short date for matter report / dashboard tables (e.g. Jan 5, 2025). */
export function toCompactDate(value?: string | null): string {
  if (!value) return "-";
  const parsed = dayjs(value);
  if (!parsed.isValid()) return "-";
  return parsed.format("MMM D, YYYY");
}
